import { observer } from 'mobx-react-lite'
import { Box, TextFieldWithLabel } from 'shared/ui'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'
import { type VerifyNumberStore } from 'pages/settings/ui/VerifyNumberCommon/store/VerifyNumberStore'

export const VerifyNumberExt = observer(({ store }: { store: VerifyNumberStore }) => {
  const { phoneNumber, setExtension, extension, nextClickHandler, nextDisabled, nextLoading } =
    store

  return (
    <>
      <Box display='flex' justifyContent='space-between' gap={'12px'}>
        <Box flex={5}>
          <TextFieldWithLabel
            labelProps={{
              label: {
                text: 'Phone number',
              },
            }}
            errorMessage={''}
            textFieldProps={{
              value: phoneNumber,
              disabled: true,
            }}
          />
        </Box>
        <Box flex={1}>
          <TextFieldWithLabel
            labelProps={{
              label: {
                text: 'Extension',
              },
            }}
            errorMessage={''}
            textFieldProps={{
              onChange: setExtension,
              value: extension,
              InputProps: {
                placeholder: '123',
              },
            }}
          />
        </Box>
      </Box>

      <NextButton
        text='Verify'
        disabled={nextDisabled}
        loading={nextLoading}
        onClick={nextClickHandler}
      />
    </>
  )
})
